import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FolderIcon from '@material-ui/icons/Folder';
import DeleteIcon from '@material-ui/icons/Delete';
import BrightnessHighIcon from '@material-ui/icons/BrightnessHigh';
import Brightness1Icon from '@material-ui/icons/Brightness1';

const useStyles = makeStyles((theme) => ({
    root: {
        textAlign: 'center'
    },
    listItem: {
        display: 'inline-block'
    },
    legendName: {
        position: 'relative',
        top: '-2px'
    },
    ulList: {
        fontSize: 11
    }
  }));

const legends = {
    "Accredited": "#62b44e",
    "Not Accredited but accepts the policy": "#00a4fd",
    "Needs Accommodation Letter": "#f6de02",
    "Not Accredited": "#fc0404",
    "No Accreditations Set": "#6e6e6e"
}

function Legends() {
    const classes = useStyles(); 
    const renderLegends = () => {
        return Object.keys(legends).map(( legend, index ) => {
            return(
                <li key={ `legend-itm-${index}` } className={ classes.listItem }>
                    <table>
                        <tr>
                            <td><BrightnessHighIcon style={{ color: legends[legend] }}/></td>
                            <td className={ classes.legendName }>{ legend }</td>
                        </tr>
                    </table>
                </li>
            )
        });
    }; 
    return(
        <div className={ classes.root }>
            <ul className={ classes.ulList }>
                <h4>Bank Accreditation Legends</h4>
                { renderLegends() }
            </ul>
        </div>
    );
}

export default Legends;